import { render, staticRenderFns } from "./TabsCustom.vue?vue&type=template&id=4bb128c5&scoped=true&"
import script from "./TabsCustom.vue?vue&type=script&lang=js&"
export * from "./TabsCustom.vue?vue&type=script&lang=js&"
import style0 from "./TabsCustom.vue?vue&type=style&index=0&id=4bb128c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb128c5",
  null
  
)

export default component.exports